export default __webpack_public_path__ + "static/media/bg_purple.9f77d850.webp";